import React from 'react'

import { useRouterScrollToTop } from '@domain-group/react-hooks'

import useIntercom from '@hooks/useIntercom'

interface PublicProps {
  children: React.ReactNode,
}

const Public = (props: PublicProps) => {
  const { children } = props

  useIntercom({ hideWidget: true })

  // Scroll Page to top when route changes
  useRouterScrollToTop()

  return children
}

export default Public
